import { getDoc } from 'firebase/firestore'

let confirmationDb

// The full SDK's getDocFromServer also uses its snapshot/listener machinery.
// Confirm a surprising absence through an independent REST read instead. Lite
// shares this Firebase app's Auth and App Check; normal Firestore rules still apply.
async function confirmFromServer(reference) {
  const lite = await import('firebase/firestore/lite')
  if (!confirmationDb) {
    confirmationDb = lite.getFirestore(reference.firestore.app)
    if (process.env.VUE_APP_USE_EMULATORS === 'true') {
      lite.connectFirestoreEmulator(confirmationDb, 'localhost', 8081)
    }
  }
  return lite.getDoc(lite.doc(confirmationDb, reference.path))
}

/** Never classify an unavailable read as a missing account. No account writes. */
export async function readAccountProfile(reference, firebaseUser) {
  let diagnostics = { confirmation: 'not-needed' }
  try {
    let snapshot
    try {
      snapshot = await getDoc(reference)
    } catch (error) {
      // Retain the existing first-read token race recovery.
      if (error?.code !== 'permission-denied') throw error
      await firebaseUser.getIdToken(true)
      snapshot = await getDoc(reference)
    }
    if (snapshot.exists()) return { snapshot, diagnostics }

    diagnostics = {
      confirmation: 'server-rest',
      initialFromCache: snapshot.metadata.fromCache,
      initialHasPendingWrites: snapshot.metadata.hasPendingWrites,
    }
    await firebaseUser.getIdToken(true)
    snapshot = await confirmFromServer(reference)
    return {
      snapshot,
      diagnostics: { ...diagnostics, outcome: snapshot.exists() ? 'recovered' : 'missing' },
    }
  } catch (cause) {
    const error = new Error('Unable to verify the account profile. Please try again.')
    error.code = 'account/profile-unavailable'
    error.profileReadDiagnostics = { ...diagnostics, causeCode: cause?.code || 'unknown' }
    throw error
  }
}
